"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = __importDefault(require("./styles"));
var Bubble = function (props) {
    var children = props.children, isHidden = props.isHidden, className = props.className, type = props.type, style = props.style;
    if (isHidden)
        return null;
    return react_1.default.createElement(styles_1.default, { className: className + " " + type, style: style }, children);
};
exports.default = Bubble;
//# sourceMappingURL=index.js.map